<template>
  <div class="ft-thumbnailer">
    <div class="ft-image" v-if="type === 'images'">
      <div v-if="file.type === 'image/vnd.adobe.photoshop'">
        <v-sheet class="ft-file-icon d-flex" :height="viewportHeight" :style="{'padding': padding}">
          <img class="ft-img" :src="require('@/assets/icons/psd-svgrepo-com.svg')" width="100" :alt="imagePreview" />
          <slot name="append"></slot>
        </v-sheet>
      </div>
      <div v-else>
        <v-sheet class="ft-file-icon" :height="viewportHeight" :style="{'padding': padding}">
          <div class="d-flex justify-center align-center" :style="{ height: '100%' }">
            <v-img
                class="ft-img"
                :height="viewportHeight"
                :style="{'padding': padding, visibility: loading ? 'hidden' : 'visible'}"
                :src="imagePreview"
                @load="loading = false"
            />
            <v-progress-circular
                v-if="loading"
                class="ft-file-loading"
                :size="80"
                :width="2"
                color="primary"
                indeterminate
            ></v-progress-circular>
          </div>
          <slot name="append"></slot>
        </v-sheet>
      </div>
    </div>
    <div v-else-if="type === 'videos'">
      <v-sheet class="ft-file-icon d-flex" :height="viewportHeight" :style="{'padding': padding}">
        <v-icon size="120" color="blue darken-1">mdi-file-video</v-icon>
        <slot name="append"></slot>
      </v-sheet>
    </div>
    <div v-else-if="type === 'audios'">
      <v-sheet class="ft-file-icon d-flex" :height="viewportHeight" :style="{'padding': padding}">
        <v-icon size="120" color="orange darken-1">mdi-file-music</v-icon>
        <slot name="append"></slot>
      </v-sheet>
    </div>
    <div v-else-if="type === 'files'">
      <div v-if="fileExt(file) === '.pdf'">
        <v-sheet class="ft-file-icon d-flex" :height="viewportHeight" :style="{'padding': padding}">
          <v-icon size="120" color="#d7221a">mdi-file-pdf-box</v-icon>
          <slot name="append"></slot>
        </v-sheet>
      </div>
      <div v-else-if="fileExt(file) === '.doc' || fileExt(file) === '.docx'">
        <v-sheet class="ft-file-icon d-flex" :height="viewportHeight" :style="{'padding': padding}">
          <v-icon size="120" color="#2a5698">mdi-file-word</v-icon>
          <slot name="append"></slot>
        </v-sheet>
      </div>
      <div v-else-if="fileExt(file) === '.odt'">
        <v-sheet class="ft-file-icon d-flex" :height="viewportHeight" :style="{'padding': padding}">
          <v-icon size="120" color="#2a5698">mdi-microsoft-word</v-icon>
          <slot name="append"></slot>
        </v-sheet>
      </div>
      <div v-else-if="fileExt(file) === '.xls' || fileExt(file) === '.xlsx'">
        <v-sheet class="ft-file-icon d-flex" :height="viewportHeight" :style="{'padding': padding}">
          <v-icon size="120" color="#227239">mdi-file-excel</v-icon>
          <slot name="append"></slot>
        </v-sheet>
      </div>
      <div v-else-if="fileExt(file) === '.ppt' || fileExt(file) === '.pptx'">
        <v-sheet class="ft-file-icon d-flex" :height="viewportHeight" :style="{'padding': padding}">
          <v-icon size="120" color="#ca4223">mdi-file-powerpoint</v-icon>
          <slot name="append"></slot>
        </v-sheet>
      </div>
      <div v-else-if="fileExt(file) === '.rar'">
        <v-sheet class="ft-file-icon d-flex" :height="viewportHeight" :style="{'padding': padding}">
          <v-icon size="120" color="brown darken-1">mdi-zip-box</v-icon>
          <slot name="append"></slot>
        </v-sheet>
      </div>
      <div v-else>
        <v-sheet class="ft-file-icon d-flex" :height="viewportHeight" :style="{'padding': padding}">
          <v-icon size="120" color="grey darken-3">mdi-file</v-icon>
          <slot name="append"></slot>
        </v-sheet>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "FileThumbnailer",
  props: {
    value: {
      required: true
    },
    viewportHeight: {
      default: 160
    },
    padding: {
      default: "0 0 0 0"
    }
  },
  data: () => ({
    type: "",
    file: {},
    imagePreview: null,
    loading: false,
  }),
  computed: {
    ...mapState({
      acceptFilesList: state => state.Media.acceptFilesList
    })
  },
  methods: {
    setImgSrc(img) {
      this.loading = true;
      if (img instanceof File) {
        return new Promise(resolve => {
          const picReader = new FileReader();
          picReader.onload = image => resolve(image.target.result);
          picReader.readAsDataURL(img);
        }).then(data => {
          this.$set(this, "imagePreview", data);
        }).finally(() => {
          this.loading = false;
        });
      } else {
        let url = this.$apiImagesUrl + "/" + img.name
        window.URL.revokeObjectURL(url)
        this.$set(this, "imagePreview", url)
        this.loading = false;
      }
    },
    fileExt(file) {
      return file.name.match("[.][a-z]+", "g")[0];
    },
    getFileType(file) {
      let accepts = this.acceptFilesList,
        type;
      for (let acceptType in accepts) {
        if (accepts[acceptType].includes(file.type)) {
          type = acceptType;
        }
      }
      return type;
    },
  },
  watch: {
    value: {
      handler(value) {
        this.type = this.getFileType(value);
        this.file = value;

        // Resim dosyası ise önizlemesini oluştur
        if (this.type === "images") {
          this.setImgSrc(this.file);
        }
      },
      immediate: true
    }
  }
};
</script>

<style>
.ft-thumbnailer {
  max-width: 100%;
  position: relative;
}

.ft-file-loading {
  top: 50%;
  transform: translateY(-50%);
  position: absolute;
}
</style>